var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.46967 13.5303C3.17678 13.2374 3.17678 12.7626 3.46967 12.4697L9.46967 6.46967C9.76256 6.17678 10.2374 6.17678 10.5303 6.46967L16.5303 12.4697C16.8232 12.7626 16.8232 13.2374 16.5303 13.5303C16.2374 13.8232 15.7626 13.8232 15.4697 13.5303L10 8.06066L4.53033 13.5303C4.23744 13.8232 3.76256 13.8232 3.46967 13.5303Z"}));
}

Chevron.defaultProps = {"viewBox":"0 0 20 20","fill":"currentColor"};

module.exports = Chevron;

Chevron.default = Chevron;
